export const IntroLimit = 50
export const FAQ_DESCRIPTION_LIMIT = 100
export const SOFTWARE_FAQ_DESCRIPTION_LIMIT = 50
export const DESCRIPTION_LIMIT = 100
export const PAGE_SIZE_FOR_PAGINATION = 20
export const SITEMAP_PAGE_SIZE_FOR_PAGINATION = 300
